namespace $.$$ {
	export class $shm_surreal_profile_form extends $.$shm_surreal_profile_form {
		profile() {
			return $shm_surreal_profile.data( this.profile_id() ) ?? {
				endpoint: '', namespace: '', database: '', username: '', password: '',
			}
		}

		draft_data( patch?: Partial< $shm_surreal_config_profile_data > ) {
			const draft = this.draft() as $shm_surreal_config_profile_data | null
			const current = draft ?? this.profile()
			if( patch ) this.draft({ ... current, ... patch })
			return patch ? { ... current, ... patch } : current
		}

		endpoint( next?: string ) {
			if( next !== undefined ) return this.draft_data({ endpoint: next }).endpoint
			return this.draft_data().endpoint
		}

		namespace( next?: string ) {
			if( next !== undefined ) return this.draft_data({ namespace: next }).namespace
			return this.draft_data().namespace
		}

		database( next?: string ) {
			if( next !== undefined ) return this.draft_data({ database: next }).database
			return this.draft_data().database
		}

		username( next?: string ) {
			if( next !== undefined ) return this.draft_data({ username: next }).username ?? ''
			return this.draft_data().username ?? ''
		}

		password( next?: string ) {
			if( next !== undefined ) return this.draft_data({ password: next }).password ?? ''
			return this.draft_data().password ?? ''
		}

		@ $mol_action
		save( next?: Event ) {
			if( !next ) return null
			const profile = this.draft_data()
			$shm_surreal_config_endpoint( profile.endpoint )
			if( !profile.namespace.trim() || !profile.database.trim() ) {
				throw new Error( 'Namespace и Database обязательны' )
			}
			$shm_surreal_profile.data( this.profile_id(), profile )
			$shm_surreal_reactive_pool.reset( this.profile_id() )
			this.draft( null )
			this.status( 'Подключение сохранено в этом браузере' )
			return next
		}
	}
}
